// AUTO-GENERATED by scripts/generate-blog-manifest.mjs — DO NOT EDIT.
// Derived from the post files in this directory; regenerated on every build.
// To publish a post, add a single <slug>.ts file — no manual registration.
import type { BlogPostMeta } from "./manifest";

// The 3 newest posts, for the landing-page BlogTeaser. Kept in its own
// module so the landing entry chunk doesn't carry the whole manifest.
export const blogTeaserPosts: BlogPostMeta[] = [
  {
    "authorId": "cristian-machado",
    "id": "mejor-software-hvac-2026-espanol",
    "title": "El mejor software para empresas de HVAC en 2026 (guía en español)",
    "description": "Comparamos los mejores programas para empresas de HVAC en 2026 — Workloop, Jobber, Housecall Pro y ServiceTitan — con precios, funciones y soporte en español.",
    "language": "es",
    "date": "2026-07-06",
    "author": "Equipo Workloop",
    "category": "Comparaciones",
    "readTime": "12 min de lectura"
  },
  {
    "authorId": "cristian-machado",
    "id": "dejar-papel-whatsapp-organizar-negocio",
    "title": "Cómo dejar el papel y WhatsApp: organiza tu negocio de servicios en una tarde",
    "description": "Guía práctica en español para pasar tu negocio de HVAC, plomería o electricidad del papel y WhatsApp a un sistema digital: agenda, facturas y técnicos organizados en una tarde.",
    "language": "es",
    "date": "2026-07-04",
    "author": "Equipo Workloop",
    "category": "Guías",
    "readTime": "11 min de lectura"
  },
  {
    "authorId": "cristian-machado",
    "id": "reduce-hvac-customer-complaints",
    "title": "7 Proven Ways to Reduce Customer Complaints in Your HVAC Business",
    "description": "Most HVAC complaints come from the same 3 problems. Here's how to fix them, get better reviews, and turn unhappy customers into referrals.",
    "language": "en",
    "date": "2026-04-01",
    "author": "Workloop Team",
    "category": "Business Growth",
    "readTime": "9 min read"
  }
];
